export const PREVIEW = 'PREVIEW'
export const EDIT = 'EDIT'



// WEBPACK FOOTER //
// ./src/constants/editorMode.js